module.exports = __webpack_public_path__ + "static/media/girl-22.6d240e9c.svg";